import { array, intersect, partial, struct, tuple } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as ClientId } from '../../client/Id';
import { Id as JobTypeId } from '../../job/job-type';
import { Id as RequirementId } from '../../report/RequirementsWithUnknown';
import { UserId } from '../UserId';

import { DateBasis } from './DateBasis';

/** Optional so filters saved against the old `showCompleted` boolean still decode. */
export const FilterRequest = intersect(
	struct({
		client: array(ClientId),
		jobType: array(JobTypeId),
		requirements: array(array(RequirementId)),
		assignee: array(UserId),
		completedAt: tuple(iotsUtils.ValidDate, iotsUtils.ValidDate),
	})
)(
	partial({
		dateBasis: DateBasis,
	})
);
